const formatWithLeadingZero = (num: number | string): string => {
  const returnString = num + ''
  return returnString.length === 1 ? '0' + returnString : returnString
}

export default formatWithLeadingZero
